import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { BRAND } from "@/config";

const LINKS = [
    { label: "Inside SHREDxpro", href: "/#showcase" },
    { label: "Membership", href: "/#membership" },
    { label: "Free Resources", href: "/resources" },
    { label: "FAQ", href: "/#faq" },
    { label: "Support", href: "/support" },
];

const Nav = () => {
    const [open, setOpen] = useState(false);
    const { user } = useAuth();
    const navigate = useNavigate();

    return (
        <header
            data-testid="site-nav"
            className="fixed inset-x-0 top-0 z-50 border-b border-white/5 bg-[#070c15]/85 backdrop-blur-md"
        >
            <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 sm:px-8">
                <Link to="/" data-testid="nav-logo-link" className="flex items-center">
                    <img src={BRAND.wordmarkNav} alt="SHREDxpro" className="h-7 w-auto sm:h-8" />
                </Link>

                <nav className="hidden items-center gap-8 lg:flex" data-testid="nav-links">
                    {LINKS.map((l) => (
                        <Link
                            key={l.label}
                            to={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className="text-sm font-semibold text-[#93a3ba] transition-colors hover:text-white"
                        >
                            {l.label}
                        </Link>
                    ))}
                </nav>

                <div className="hidden items-center gap-5 lg:flex">
                    {user ? (
                        <button
                            data-testid="nav-account-link"
                            onClick={() => navigate("/account")}
                            className="text-sm font-semibold text-[#c8d3e2] transition-colors hover:text-white"
                        >
                            Account
                        </button>
                    ) : (
                        <Link
                            to="/login"
                            data-testid="nav-login-link"
                            className="text-sm font-semibold text-[#c8d3e2] transition-colors hover:text-white"
                        >
                            Sign In
                        </Link>
                    )}
                    <Link to={user ? "/trial" : "/register?trial=1"} data-testid="nav-trial-cta" className="btn-cyan !px-5 !py-2.5 !text-xs">
                        Start Free
                    </Link>
                </div>

                <button
                    data-testid="nav-mobile-toggle"
                    className="text-white lg:hidden"
                    onClick={() => setOpen(!open)}
                    aria-label="Toggle menu"
                >
                    {open ? <X /> : <Menu />}
                </button>
            </div>

            {open && (
                <div
                    data-testid="nav-mobile-menu"
                    className="border-t border-white/5 bg-[#070c15] px-5 py-6 lg:hidden"
                >
                    <div className="flex flex-col gap-5">
                        {LINKS.map((l) => (
                            <Link
                                key={l.label}
                                to={l.href}
                                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                onClick={() => setOpen(false)}
                                className="text-sm font-semibold text-[#c8d3e2]"
                            >
                                {l.label}
                            </Link>
                        ))}
                        <Link
                            to={user ? "/account" : "/login"}
                            data-testid="nav-mobile-login-link"
                            onClick={() => setOpen(false)}
                            className="text-sm font-semibold text-[#c8d3e2]"
                        >
                            {user ? "Account" : "Sign In"}
                        </Link>
                        <Link
                            to={user ? "/trial" : "/register?trial=1"}
                            data-testid="nav-mobile-trial-cta"
                            onClick={() => setOpen(false)}
                            className="btn-primary"
                        >
                            Start 7-Day Free Trial
                        </Link>
                    </div>
                </div>
            )}
        </header>
    );
};

export default Nav;
